class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.primary_button = this.querySelector('.product-buy-buttons--primary')),
      (this.button_text = this.querySelector('.product-buy-buttons--cta-text')),
      (this.select_input = this.querySelector('.product-buy-buttons--select')),
      (this.smart_button = this.querySelector('.product-buy-buttons--smart')),
      this.addToCartListener(),
      this.updateViewListener();
  }
  addToCartListener() {
    this.closest('form').on('submit', async (t) => {
      var e = this.querySelector('option[selected]')['dataset'],
        r = t.target.querySelector('[name=quantity]'),
        a = theme.utils.getQuantity(this.dataset.id, e, r.value);
      if (
        (('drawer' !== theme.settings.cart_type && !1 !== a) ||
          (t.preventDefault(), t.stopPropagation()),
        a &&
          (this.primary_button.setAttribute('aria-busy', !0),
          'drawer' === theme.settings.cart_type))
      ) {
        var i = new FormData(t.target),
          s = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(i).toString(),
          };
        try {
          await theme.cart.addItem(s, e.id),
            this.primary_button.setAttribute('aria-busy', !1),
            theme.drawer.open('right', 'cart-drawer', this.primary_button);
        } catch (t) {
          throw (
            (this.primary_button.setAttribute('aria-busy', !1), new Error(t))
          );
        }
      }
    });
  }
  updateViewListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        var e = this.select_input.querySelector('option[selected]');
        e && e.removeAttribute('selected'),
          t && t.available
            ? (this.selectVariant(t.id), this.updateView(!0, !0))
            : t && !t.available
            ? (this.selectVariant(t.id), this.updateView(!1, !0))
            : this.updateView(!1, !1);
      }
    );
  }
  selectVariant(t) {
    var e = this.select_input.querySelector(`option[value='${t}']`);
    e && e.setAttribute('selected', !0);
  }
  updateView(t, e) {
    t
      ? (this.primary_button.removeAttribute('disabled'),
        (this.button_text.innerText = theme.translations.add_to_cart),
        this.smart_button && this.smart_button.setAttribute('aria-hidden', !1))
      : (this.primary_button.setAttribute('disabled', !0),
        this.smart_button && this.smart_button.setAttribute('aria-hidden', !0),
        (this.button_text.innerText = e
          ? theme.translations.out_of_stock
          : theme.translations.unavailable));
  }
}
const productBuyButtonsEl = customElements.get('product-buy-buttons-root');
productBuyButtonsEl ||
  customElements.define('product-buy-buttons-root', ProductBuyButtons);
